export default {
	title: '指標',
	url: 'indicators',
	subtitle:
		"成功指標を一覧化し、カテゴリーごとに整理します。デフォルトはバランスト・スコアカードの4つの視点（財務、顧客、業務プロセス、学習と成長）です。可視化タブでは、シナリオごとの推移とともにスコアカード形式で表示されます。",
	no_description: '指標が未定義です',
	context_worse: 'ネガティブ',
	context_best: 'ポジティブ',
	tabs: {
		filters: {
			title: '表示フィルター'
		},
		general: {
			title: '一般'
		},
		export: {
			title: 'エクスポート'
		},
		comments: {
			title: '履歴'
		},
		bot: {
			title: 'AI'
		}
	},
	messages: {
		edit_constraint: '指標の編集',
		create_constraint: '新しい指標を作成'
	},
	onboarding: {
		title: '指標のレビュー',
		description:
			"指標がバランスト・スコアカードのカテゴリーを網羅し、アクションプランに紐づいていることを確認してください。"
	}
};
